import { IServices } from "@netent/origin";
import { IGameHistoryState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

// 1. If game history is not available and if playing for fun the feature should not be available or enabled
// 2. If game history is not available and if playing for real the feature should not be available or enabled
// 3. If game history is available and if playing for real, then it should be enabled
// 4. If game history is available and if playing for fun, then it should be disabled
export const gameHistoryState: FeatureStateCreator<IGameHistoryState> = (
  services: IServices
): IGameHistoryState => {
  const isAvailable = services.game.isGameHistoryAvailable();
  const isPlayForFun = services.game.isPlayForFun();
  const enabled = isAvailable && !isPlayForFun;

  return !isAvailable
    ? null
    : {
        enabled
      };
};
